/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs */

const en_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const ar_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const de_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const es_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const fr_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const it_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const ja_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const ko_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const pt_br_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const ru_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const th_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const tr_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying all your Plus benefits without interruption.`)
};

const zh_cn_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Plus 会员有效期已延长，继续享受 Plus  专属特权！`)
};

const zh_tw_onboarding_paywall_subscribed_success_content_extend_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Plus 会员有效期已延长，继续享受 Plus  专属特权！`)
};

/**
* | output |
* | --- |
* | "Keep enjoying all your Plus benefits without interruption." |
*
* @param {Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_subscribed_success_content_extend_cna = /** @type {((inputs?: Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Subscribed_Success_Content_Extend_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "ar") return ar_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "de") return de_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "es") return es_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "fr") return fr_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "it") return it_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "ja") return ja_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "ko") return ko_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "ru") return ru_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "th") return th_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "tr") return tr_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
	return zh_tw_onboarding_paywall_subscribed_success_content_extend_cna(inputs)
});